import Layout from '../layout/Layout';

import { useTranslation } from 'react-i18next';
import CarFilterSection from '../components/carListingPage/CarListFilterSection';
import CarListSection from '../components/carListingPage/CarListSection';
import ListingOverviewWidget from '../components/ListingOverviewWidget';
import { SetMeta } from '../utils/Helper/jsHelpers';

const VoetstootsTradeSale = () => {
    const { t } = useTranslation();

    return (
        <>
            <SetMeta
                title={t('voetstootsTradeSalePageTitle')}
                desc={t('voetstootsTradeSalePageDesc')}
                keywords={t('voetstootsTradeSalePageKeywords')}
            />
            <Layout showWhiteNavbar>
                <div className="listing-page">
                    <CarFilterSection />
                    <ListingOverviewWidget
                        title={t('voetstootsTradeSalePageTitle')}
                        description={t('voetstootsTradeSalePageDesc')}
                    />
                    <CarListSection voetstoots />
                </div>
            </Layout>
        </>
    );
};
export default VoetstootsTradeSale;
